import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor, BreakpointQueryName,
} from '@doveit/lego';

export const grid: ThemedFunctor = () => css`
  display: flex;
  flex-wrap: wrap;
`;

export const column: ThemedFunctor = ({
  theme,
}) => css`
  flex: 1 0 100%;

  &:last-of-type {
    margin-top: ${theme.spaceUnits.mobile.BIG};
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    &:first-of-type {
      flex: 1 0 60%;
      ${getSpacing.paddingRight(theme, SpacingName.BIG)};
    }

    &:last-of-type {
      flex: 1 0 40%;
      margin-top: 0;
    }
  }
`;

export const videoWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin: 0;
  }
`;

export const cta: ThemedFunctor = ({
  theme,
}) => css`
  text-align: center;
  ${getSpacing.margin(theme, [SpacingName.MEDIUM, SpacingName.AUTO, 0, SpacingName.AUTO])}
  max-width: 20rem;
`;

export const offersWrapper: ThemedFunctor = () => css`
  margin: 0 auto;
  max-width: 54rem;
`;
